/* unplugin-vue-components disabled */import script from "./RewardPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardPoints.vue?vue&type=script&setup=true&lang=js"

import "./RewardPoints.vue?vue&type=style&index=0&id=58a5d918&lang=scss"

const __exports__ = script;

export default __exports__